exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "\n.drawer-form-layout-wrap > .el-drawer__header {\n  background-color: #004ec3 !important;\n  padding: 10px 15px !important;\n  margin-bottom: 0 !important;\n  color: #333333 !important;\n}\n.drawer-form-layout-wrap > .el-drawer__body {\n  height: 100%;\n  width: 100%;\n  overflow: hidden;\n}\n.drawer-form-layout-wrap > .el-drawer__body > .content-wrap {\n    width: 100%;\n    height: calc(100% - 50px);\n    overflow-y: auto;\n    padding: 10px;\n}\n.drawer-form-layout-wrap > .el-drawer__body > .footer-button-wrap {\n    padding-top: 10px;\n    width: 100%;\n    text-align: center;\n    border-top: 1px solid #ececec;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-1d5a734b","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/layout/DrawerFormLayout.vue
// module id = LSRk
// module chunks = 289